<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.databaseName')" prop="databaseName">
          <Input v-model="resourceApplicationForm.databaseName" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.databaseEngine')" prop="databaseEngine">
          <Select v-model="resourceApplicationForm.databaseEngine" filterable
                  @on-change="changeDatabaseEngine(resourceApplicationForm.databaseEngine)">
            <Option :value="item.engineType" v-for="(item,index) in databaseEngineList" :key="index">
              {{item.engineType}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.databaseVersion')" prop="databaseVersion">
          <Select v-model="resourceApplicationForm.databaseVersion" filterable
                  @on-change="changeDatabaseVersion(resourceApplicationForm.databaseVersion)">
            <Option :value="item.engine" v-for="(item,index) in databaseVersionList" :key="index">{{item.engine}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.databaseEngineVersion')" prop="databaseEngineVersion">
          <Select v-model="resourceApplicationForm.databaseEngineVersion" filterable
                  @on-change="changeDatabaseEngineVersion(resourceApplicationForm.databaseEngineVersion)">
            <Option :value="item.name" v-for="(item,index) in databaseEngineVersionList" :key="index">{{item.name}}
              ({{item.dbParameterGroupFamily}})
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.databaseInstanceType')" prop="databaseInstanceClass">
          <Select v-model="resourceApplicationForm.databaseInstanceClass" filterable @on-change="queryAWSRDSPrice">
            <Option :value="item.instanceType" v-for="(item,index) in databaseInstanceClassList" :key="index">
              {{item.databaseInstanceClass}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.multiAZDeployment')" prop="multiAZDeployment">
          <RadioGroup v-model="resourceApplicationForm.multiAZDeployment" @on-change="queryAWSRDSPrice">
            <Radio v-for="list in multiAZDeploymentList" :label="list.multiAZDeployment" :key="list.value">
              {{list.label}}
            </Radio>
          </RadioGroup>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.allocatedStorageSpace')" prop="allocatedStorageSpace">
          <InputNumber :min="100" :max="65536" v-model="resourceApplicationForm.allocatedStorageSpace"
                       :active-change="false"></InputNumber>
          GiB
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.storageType')" prop="storageType">
          <Select v-model="resourceApplicationForm.storageType" filterable>
            <Option :value="item.label" v-for="item in storageTypeList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row v-if="resourceApplicationForm.storageType=='io1'">
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.presetIOPS')" prop="presetIOPS">
          <InputNumber v-model="resourceApplicationForm.presetIOPS"></InputNumber>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.masterUsername')" prop="masterUsername">
          <Input v-model="resourceApplicationForm.masterUsername" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.masterPassword')" prop="password">
          <Input v-model="resourceApplicationForm.password" type="password"></Input>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.port')" prop="port">
          <InputNumber v-model="resourceApplicationForm.port"></InputNumber>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.databaseParameterGroup')" prop="databaseParameterGroup">
          <Select v-model="resourceApplicationForm.databaseParameterGroup" filterable>
            <Option :value="item.dbparameterGroupName" v-for="(item,index) in databaseParameterGroupList" :key="index">
              {{item.dbparameterGroupName}}
            </Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.optionGroup')" prop="optionGroup">
          <Select v-model="resourceApplicationForm.optionGroup" filterable>
            <Option :value="item.optionGroupName" v-for="(item,index) in optionGroupList" :key="index">
              {{item.optionGroupName}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.iamDatabaseAuthentication')" prop="iamDatabaseAuthentication">
          <RadioGroup v-model="resourceApplicationForm.iamDatabaseAuthentication">
            <Radio v-for="list in iamDatabaseAuthenticationList" :label="list.iamDatabaseAuthentication"
                   :key="list.value">{{list.label}}
            </Radio>
          </RadioGroup>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem label="VPC" prop="vpc">
          <Select v-model="resourceApplicationForm.vpc" filterable @on-change="queryAWSSubnetList">
            <Option :value="item.vpcId" v-for="item in vpcList" v-bind:key="item.vpcId">{{item.vpcId+"("+item.name+")"}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.subnetGroup')" prop="subnetGroup">
          <Select v-model="resourceApplicationForm.subnetGroup" filterable>
            <Option :value="item.dbsubnetGroupName" v-for="item in subnetGroupList" v-bind:key="item.dbsubnetGroupName">
              {{item.dbsubnetGroupName}}
            </Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.publicAvailability')" prop="publicAvailability">
          <RadioGroup v-model="resourceApplicationForm.publicAvailability">
            <Radio v-for="list in publicAvailabilityList" :label="list.publicAvailability" :key="list.value">
              {{list.label}}
            </Radio>
          </RadioGroup>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.availabilityZone')" prop="availabilityZone">
          <Select v-model="resourceApplicationForm.availabilityZone" filterable>
            <Option :value="item.zoneName" v-for="(item,index) in availabilityZoneList" :key="index">{{item.zoneName}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.vpcSecurityGroup')" prop="vpcSecurityGroup">
          <RadioGroup v-model="resourceApplicationForm.vpcSecurityGroup">
            <Radio v-for="list in vpcSecurityGroupList" :label="list.vpcSecurityGroup" :key="list.value">
              {{list.label}}
            </Radio>
          </RadioGroup>
        </FormItem>
      </Col>
    </Row>

    <!-- 当VPC安全组为 选择现有VPC安全组时显示 -->
    <Row v-if="resourceApplicationForm.vpcSecurityGroup==1">
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.existingSecurityGroup')" prop="existingSecurityGroup">
          <Select v-model="resourceApplicationForm.existingSecurityGroup" filterable multiple :max-tag-count="1"
                  :placeholder="$t('resourceLifecycle.queryByPurpose')"
                  @on-change="changeExistingSecurityGroup(resourceApplicationForm.existingSecurityGroup)"
                  :transfer="true">
            <Checkbox v-model="singleExistingSecurityGroup" @on-change="selectExistingSecurityGroupAll"
                      style="display: block;text-align:right;">{{$t('resourceLifecycle.selectAll')}}
            </Checkbox>
            <Option :value="item.groupId" v-for="(item,index) in existingSecurityGroupList" :key="index">
              {{item.groupId}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.copyTagsToSnapshot')" prop="copyTagsToSnapshot">
          <RadioGroup v-model="resourceApplicationForm.copyTagsToSnapshot">
            <Radio v-for="list in copyTagsToSnapshotList" :label="list.copyTagsToSnapshot" :key="list.value">
              {{list.label}}
            </Radio>
          </RadioGroup>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.enableDeleteProtection')" prop="enableDeleteProtection">
          <RadioGroup v-model="resourceApplicationForm.enableDeleteProtection">
            <Radio v-for="list in enableDeleteProtectionList" :label="list.enableDeleteProtection" :key="list.value">
              {{list.label}}
            </Radio>
          </RadioGroup>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>
  import {setCookie, getCookie, delCookie} from '../../../../../utils/cookieUtil.js'

  export default {
    name: 'AmazonManagedDatabase',
    props: ['amazonResourceApplicationBasicInfoForm', 'cost'],
    components: {},
    data() {
      return {
        dbParameterGroupFamily: '',
        databaseEngineList: [],
        storageTypeList: [{
          id: 0,
          label: 'gp2',
          name: this.$t("resourceLifecycle.universalSSD")
        }, {
          id: 1,
          label: 'io1',
          name: this.$t("resourceLifecycle.presetIOPSSSD")
        }],
        multiAZDeploymentList: [{
          label: this.$t("resourceLifecycle.createcopiesindifferentregions"),
          value: 'createCopiesInDifferentAreas',
          multiAZDeployment: 1
        }, {
          label: this.$t("resourceLifecycle.no"),
          value: 'no',
          multiAZDeployment: 0
        }],
        iamDatabaseAuthenticationList: [{
          label: this.$t("resourceLifecycle.enableIAMdatabaseauthentication"),
          value: 'enable',
          iamDatabaseAuthentication: 1
        }, {
          label: this.$t("resourceLifecycle.disable"),
          value: 'disable',
          iamDatabaseAuthentication: 0
        }],
        publicAvailabilityList: [{
          label: this.$t("resourceLifecycle.yes"),
          value: 'yes',
          publicAvailability: 1
        }, {
          label: this.$t("resourceLifecycle.no"),
          value: 'no',
          publicAvailability: 0
        }],
        copyTagsToSnapshotList: [{
          label: this.$t("resourceLifecycle.yes"),
          value: 'yes',
          copyTagsToSnapshot: 1
        }, {
          label: this.$t("resourceLifecycle.no"),
          value: 'no',
          copyTagsToSnapshot: 0
        }],
        enableDeleteProtectionList: [{
          label: this.$t("resourceLifecycle.yes"),
          value: 'yes',
          enableDeleteProtection: 1
        }, {
          label: this.$t("resourceLifecycle.no"),
          value: 'no',
          enableDeleteProtection: 0
        }],
        vpcSecurityGroupList: [{
          label: this.$t("resourceLifecycle.createanewVPCsecuritygroup"),
          value: 'create',
          vpcSecurityGroup: 0
        }, {
          label: this.$t("resourceLifecycle.selectanexistingVPCsecuritygroup"),
          value: 'choose',
          vpcSecurityGroup: 1
        }],
        databaseParameterGroupList: [],
        optionGroupList: [],
        vpcList: [],
        subnetGroupList: [],
        availabilityZone: [],
        databaseEngineVersionList: [],
        databaseInstanceClassList: [],
        availabilityZoneList: [],
        singleExistingSecurityGroup: false,
        existingSecurityGroupList: [],
        databaseVersionList: [],
        resourceApplicationForm: {
          databaseName: '',
          databaseEngine: '',
          databaseEngineVersion: '',
          databaseInstanceClass: '',
          multiAZDeployment: 0,
          storageType: 'gp2',
          allocatedStorageSpace: 20,
          presetIOPS: null,
          masterUsername: '',
          password: '',
          port: 3306,
          databaseParameterGroup: '',
          optionGroup: '',
          iamDatabaseAuthentication: 1,
          vpc: '',
          subnetGroup: '',
          publicAvailability: 0,
          availabilityZone: '',
          vpcSecurityGroup: 0,
          existingSecurityGroup: [],
          copyTagsToSnapshot: 0,
          enableDeleteProtection: 0,
          databaseVersion: '',
          cost: 0
        },
        ruleValidate: {
          databaseName: [
            {required: true, message: this.$t("resourceLifecycle.databasenamecannotbeempty"), trigger: 'blur'}
          ],
          databaseEngine: [
            {required: true, message: this.$t("resourceLifecycle.pleaseselectadatabaseengine"), trigger: 'change'}
          ],
          databaseEngineVersion: [
            {required: true, message: this.$t("resourceLifecycle.pleaseselectthedatabaseengineversion"), trigger: 'change'}
          ],
          databaseVersion: [
            {required: true, message: this.$t("resourceLifecycle.pleaseselectthedatabaseversion"), trigger: 'change'}
          ],
          databaseInstanceClass: [
            {required: true, message: this.$t("resourceLifecycle.pleaseselectthedatabaseinstancetype"), trigger: 'change'}
          ],
          multiAZDeployment: [
            {required: true, message: 'this.$t("resourceLifecycle.pleaseselectmultizonedeployment")', trigger: 'change', type: 'number'}
          ],
          storageType: [
            {required: true, message: 'this.$t("resourceLifecycle.pleaseselectstoragetype")', trigger: 'change'}
          ],
          allocatedStorageSpace: [
            {required: true, message: 'this.$t("resourceLifecycle.pleaseentertheallocatedstoragespace")', trigger: 'blur', type: 'number'}
          ],
          presetIOPS: [
            {required: true, message: 'this.$t("resourceLifecycle.pleaseenterthepresetIOPS")', trigger: 'blur', type: 'number'}
          ],
          masterUsername: [
            {required: true, message: 'this.$t("resourceLifecycle.themainusernamecannotbeempty")', trigger: 'blur'}
          ],
          password: [
            {required: true, message: 'this.$t("resourceLifecycle.masterpasswordcannotbeempty")', trigger: 'blur'}
          ],
          port: [
            {required: true, message: 'this.$t("resourceLifecycle.pleaseentertheport")', trigger: 'blur', type: 'number'}
          ],
          databaseParameterGroup: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectDatabaseParameterGroup' ), trigger: 'change', type: 'number'}
          ],
          optionGroup: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectanoptiongroup' ), trigger: 'change'}
          ],
          iamDatabaseAuthentication: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectIAMDatabaseAuthentication' ), trigger: 'change', type: 'number'}
          ],
          vpc: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectvpc' ), trigger: 'change'}
          ],
          subnetGroup: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectSubnetGroup' ), trigger: 'change'}
          ],
          publicAvailability: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectPublicAvailability' ), trigger: 'change', type: 'number'}
          ],
          availabilityZone: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectanAvailabilityZone' ), trigger: 'change'}
          ],
          vpcSecurityGroup: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectVPCSecurityGroup' ), trigger: 'change', type: 'number'}
          ],
          existingSecurityGroup: [
            {required: true, type: 'array', message: this.$t( 'resourceLifecycle.pleaseselectanexistingsecuritygroup' ), trigger: 'change'}
          ]
        }
      }
    },
    mounted: function () {
    },
    methods: {
      showAll: function () {
        this.listAWSRDSEngine();
        this.listDatabaseInstanceClass();
        this.queryAWSVpcList();
        this.queryAWSAvailableZoneList();
      },
      //查询价格
      queryAWSRDSPrice: function () {
        var submitLifecycleResourceApplicationDTO = {
          "duration": this.amazonResourceApplicationBasicInfoForm.periodOfUse,
          "region": this.amazonResourceApplicationBasicInfoForm.region,
          "lifecycleResourceAwsDatabaseDTO": {
            "dbInstanceClass": this.resourceApplicationForm.databaseInstanceClass,
            "multiAZ": this.resourceApplicationForm.multiAZDeployment,
            "engine": this.resourceApplicationForm.databaseEngine
          }
        }
        this.$api.awsPrice.queryAWSRDSPrice(submitLifecycleResourceApplicationDTO)
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      },
      /*****************数据库引擎*********************************/
      // 数据库引擎
      listAWSRDSEngine: function () {
        this.$api.lifecycleResourceApplication.listAWSRDSEngine({})
          .then(res => {
            if (res.data) {
              this.databaseEngineList = res.data;
              this.resourceApplicationForm.databaseEngine = this.databaseEngineList[0].engineType;
              this.listAWSRDSVersions();
            }
          })
      },
      // 切换数据库引擎
      changeDatabaseEngine: function () {
        this.listAWSRDSVersions();
        this.listDatabaseInstanceClass();
        this.queryAWSRDSPrice();
      },
      /*****************数据库版本*********************************/
      // 数据库版本
      listAWSRDSVersions: function () {
        this.resourceApplicationForm.databaseVersion = '';
        this.databaseVersionList = [];
        this.$api.lifecycleResourceApplication.listAWSRDSVersions({
          "engineType": this.resourceApplicationForm.databaseEngine
        })
          .then(res => {
            if (res.data) {
              this.databaseVersionList = res.data;
              if (this.databaseVersionList != null && this.databaseVersionList != undefined && this.databaseVersionList.length > 0) {
                this.resourceApplicationForm.databaseVersion = this.databaseVersionList[0].engine;
                this.listAWSRDSEngineVersions();
              }
            }
          })
      },
      // 切换数据库版本
      changeDatabaseVersion: function () {
        this.listAWSRDSEngineVersions();
        this.describeOptionGroups();
      },
      /*****************数据库引擎版本*********************************/
      // 数据库引擎版本
      listAWSRDSEngineVersions: function () {
        this.databaseEngineVersionList = [];
        this.resourceApplicationForm.databaseEngineVersion = '';
        this.$api.lifecycleResourceApplication.listAWSRDSEngineVersions({
          "engine": this.resourceApplicationForm.databaseVersion,
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            if (res.data.dbEngineVersionList) {
              this.databaseEngineVersionList = res.data.dbEngineVersionList;
              if (this.databaseEngineVersionList != null && this.databaseEngineVersionList != undefined && this.databaseEngineVersionList.length > 0) {
                this.resourceApplicationForm.databaseEngineVersion = this.databaseEngineVersionList[0].name;
                this.queryDbParameterGroupFamily();
                this.describeOptionGroups();
              }
            }
          })
      },
      // 切换数据库引擎版本
      changeDatabaseEngineVersion: function () {
        this.queryDbParameterGroupFamily();
        this.describeOptionGroups();
      },
      // 查询引擎参数组
      queryDbParameterGroupFamily(params) {
        this.resourceApplicationForm.databaseParameterGroup = '';
        this.databaseParameterGroupList = [];
        this.$api.lifecycleResourceApplication.queryDbParameterGroupFamily({
          "engine": this.resourceApplicationForm.databaseVersion,
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region,
          "engineVersion": this.resourceApplicationForm.databaseEngineVersion
        })
          .then(res => {
            this.dbParameterGroupFamily = res.data.dbParameterGroupFamily;
            if (this.dbParameterGroupFamily != null && this.dbParameterGroupFamily != undefined && this.dbParameterGroupFamily != '') {
              this.listAWSRDSdescribeDBParameterGroups();
            }
          })
      },
      /*****************数据库实体类*********************************/
      // 数据库实体类
      listDatabaseInstanceClass: function () {
        this.databaseInstanceClassList = [];
        this.resourceApplicationForm.databaseInstanceClass = '';
        this.$api.price.listDatabaseInstanceClass({
          "region": this.amazonResourceApplicationBasicInfoForm.region,
          "databaseEngine": this.resourceApplicationForm.databaseEngine
        })
          .then(res => {
            if (res.data) {
              this.databaseInstanceClassList = res.data;
              if (this.databaseInstanceClassList != null && this.databaseInstanceClassList != undefined && this.databaseInstanceClassList.length > 0) {
                this.resourceApplicationForm.databaseInstanceClass = this.databaseInstanceClassList[0].instanceType;
                this.queryAWSRDSPrice();
              }
            }
          })
      },
      /*****************数据库参数组*********************************/
      // 数据库参数组
      listAWSRDSdescribeDBParameterGroups: function () {
        this.databaseParameterGroupList = [];
        this.resourceApplicationForm.databaseParameterGroup = '';
        this.$api.lifecycleResourceApplication.listAWSRDSdescribeDBParameterGroups({
          "dbParameterGroupFamily": this.dbParameterGroupFamily,
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            if (res.data.dbParameterGroupList != null && res.data.dbParameterGroupList != undefined && res.data.dbParameterGroupList.length > 0) {
              this.databaseParameterGroupList = res.data.dbParameterGroupList;
            }
          })
      },
      // vpc
      queryAWSVpcList: function () {
        this.$api.lifecycleResourceApplication.queryAWSVpcList({
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            if (res.data) {
              this.vpcList = res.data;
              this.resourceApplicationForm.vpc = this.vpcList[0].vpcId;
              this.describeSecurityGroups();
              this.queryAWSSubnetList();
            }
          })
      },
      //查询子网
      queryAWSSubnetList: function () {
        this.describeSecurityGroups();
        this.resourceApplicationForm.subnetGroup = '';
        this.subnetGroupList = [];
        this.$api.lifecycleResourceApplication.queryAWSSubnetListByVpcId({
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region,
          "vpcId": this.resourceApplicationForm.vpc,
        })
          .then(res => {
            if (res.data) {
              this.subnetGroupList = res.data;
              if (this.subnetGroupList != null && this.subnetGroupList != undefined && this.subnetGroupList.length > 0) {
                this.resourceApplicationForm.subnetGroup = this.subnetGroupList[0].dbsubnetGroupName;
              }
            }
          })
      },
      //查询AWS可用区
      queryAWSAvailableZoneList: function () {
        this.$api.lifecycleResourceApplication.queryAWSAvailableZoneList({
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            if (res.data) {
              this.availabilityZoneList = res.data;
              this.resourceApplicationForm.availabilityZone = this.availabilityZoneList[0].zoneName;
            }
          })
      },
      /*****************选项组*********************************/
      // 选项组
      describeOptionGroups: function () {
        this.optionGroupList = [];
        this.resourceApplicationForm.optionGroup = '';
        this.$api.lifecycleResourceApplication.describeOptionGroups({
          "engineVersion": this.resourceApplicationForm.databaseEngineVersion,
          "engine": this.resourceApplicationForm.databaseVersion,
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            if (res.data.optionGroupList != null && res.data.optionGroupList != undefined && res.data.optionGroupList.length > 0) {
              this.optionGroupList = res.data.optionGroupList;
            }
          })
      },
      /*****************现有安全组*********************************/
      // 现有安全组
      describeSecurityGroups: function () {
        this.resourceApplicationForm.existingSecurityGroup = '';
        this.existingSecurityGroupList = [];
        this.$api.lifecycleResourceApplication.describeSecurityGroups({
          "vpcId": this.resourceApplicationForm.vpc,
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            if (res.data.securityGroupList) {
              this.existingSecurityGroupList = res.data.securityGroupList;
              this.resourceApplicationForm.existingSecurityGroup = this.existingSecurityGroupList[0].groupId;
            }
          })
      },
      // 切换现有安全组
      changeExistingSecurityGroup: function (val) {
        if (val.length === this.existingSecurityGroupList.length&&val.length!=0) {
          this.singleExistingSecurityGroup = true
        } else {
          this.singleExistingSecurityGroup = false
        }
      },
      // 全选现有安全组
      selectExistingSecurityGroupAll() {
        this.resourceApplicationForm.existingSecurityGroup = [];
        if (this.singleExistingSecurityGroup) {
          this.existingSecurityGroupList.map((item) => {
            this.resourceApplicationForm.existingSecurityGroup.push(item.groupId)
          })
        } else {
          this.resourceApplicationForm.existingSecurityGroup = [];
        }
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/aws/managed_database/AmazonManagedDatabase.vue